export const PRICE_BREAKUP_INFO = {
  activationText: `Your HealthFirst plan will be activated on`,
  illnessInfoText: 'Protect your family from critical illnesses with a small extra fee',
  insurancePitchText: 'Increase coverage to 5 lakhs by paying just a little more',
  insurancePitchText1: 'Protect your family from critical illnesses with lump sum payouts covers start at <strong>₹ 1,000</strong>',
  dialogInfo: {
    title: 'Protect your family from',
    subTitle: 'critical illnesses',
    strongContent: 'A critical illness cover provides financial security in the face of serious health issues (listed below), easing the burden on you and your family.',
    list: [
      'Cancer of specified severity',
      'Coma of specified severity',
      'Kidney failure requiring regular dialysis',
      'Major organ /bone marrow transplant',
      'Motor neuron disease with permanent symptoms Multiple sclerosis with persisting symptoms',
      'Multiple sclerosis with persisting symptoms Myocardial infarction',
      'Open chest CABG',
      'Open heart replacement or repair of heart valves',
      'Permanent paralysis of limbs',
      'Stroke resulting in permanent symptoms'
    ],
    proceedBtnLabel: 'YES, I WANT THIS FOR MY FAMILY',
    noBtnLabel: 'NO I DON\'T WISH TO'
  }
}